import React, {useCallback, useEffect} from 'react';
import {observer} from 'mobx-react';
import {Loader} from '../../components';
import {BankAccountForm} from './BankAccountForm';
import {startForm} from '../../../../_shared/GWTBridge/invoke/netForm';
import {bankAccountFormStore} from '../../store/OB_BankAccount_Store';
import {ErrorScreen} from '../Error/ErrorScreens';
import {formName} from './constants';
import {onboardingMessageStore} from '../../store/OB_Message_Store';
import {priority} from '@priority-software/priority-proto-api/lib';
import {sendMonitor} from '../../../../utils/monitoring';

const ErrorType = priority.netitems.shared.Message.Type;

type Props = {
    onSubmit: (id: string) => void;
    onGoOutside?: (cbc?: () => void) => void;
    id: string;
};

export const BankAccount = observer(({onSubmit, id, onGoOutside}: Props) => {
    const {isLoading, isSubmitting, bankData, fieldUpdate, editRecordMode} = bankAccountFormStore;
    const {message, clearMessage} = onboardingMessageStore;
    const isReadOnly = !editRecordMode;

    const goToBankAccount = useCallback(() => {
        sendMonitor('OnboardingTabsBankForm');
        const navigationCallback = async () => await startForm(formName);

        onGoOutside(navigationCallback);
    }, [onGoOutside]);

    const goToNext = useCallback(() => {
        onSubmit(id);
    }, [onSubmit, id]);

    const onSaveDetails = useCallback(async formValues => {
        await bankAccountFormStore.saveBankAccount(formValues);
    }, []);

    const onHyperLinkCLick = useCallback(
        (linkData: {eName: string}) => {
            const navigationCallback = async () => await startForm(linkData.eName);

            onGoOutside(navigationCallback);
        },
        [onGoOutside]
    );

    useEffect(() => {
        (async () => await bankAccountFormStore.getBankAccountData())();
    }, []);

    if (isLoading) {
        return <Loader componentClasses="onboarding-loader" width={80} height={80} />;
    }

    if (message?.message?.MType === ErrorType.Fatal) {
        return (
            <ErrorScreen
                messageData={message}
                clearMessage={clearMessage}
                handler={bankAccountFormStore.getBankAccountData}
            />
        );
    }

    return (
        <BankAccountForm
            onHyperLinkClick={onHyperLinkCLick}
            bankData={bankData}
            goToNext={goToNext}
            openBanksForm={goToBankAccount}
            onFieldUpdate={fieldUpdate}
            isSubmitted={isSubmitting}
            onSaveDetails={onSaveDetails}
            isReadOnly={isReadOnly}
        />
    );
});
